import React from 'react';
import Nprogress from 'nprogress';
import componentLoader from './componentLoader';
import 'nprogress/nprogress.css';

const safeNprogressStart = () => {
  try {
    if (typeof document !== 'undefined' && document.body) Nprogress.start();
  } catch (e) {
    // noop
  }
};

const safeNprogressDone = () => {
  try {
    Nprogress.done();
  } catch (e) {
    // noop
  }
};

export default function asyncComponent(importComponent, hideNprogress = false) {
  class AsyncFunc extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        Component: null,
      };
      if (!hideNprogress) {
        safeNprogressStart();
      }
    }

    async componentDidMount() {
      this.mounted = true;
      try {
        const { default: Component } = await componentLoader(() => importComponent(), 3);
        if (this.mounted) {
          this.setState({ Component });
        }
      } catch (e) {
        // noop
      } finally {
        if (!hideNprogress) {
          safeNprogressDone();
        }
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      const { Component } = this.state;
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        Component ? <Component {...this.props} /> : null
      );
    }
  }
  return AsyncFunc;
}
